// Automatisch erzeugt durch scripts/generateTruckFrames.cjs
import frame0 from 'url:../../img/truck/img_truck_00000.jpg?as=webp';
import frame1 from 'url:../../img/truck/img_truck_00001.jpg?as=webp';
import frame2 from 'url:../../img/truck/img_truck_00002.jpg?as=webp';
import frame3 from 'url:../../img/truck/img_truck_00003.jpg?as=webp';
import frame4 from 'url:../../img/truck/img_truck_00004.jpg?as=webp';
import frame5 from 'url:../../img/truck/img_truck_00005.jpg?as=webp';
import frame6 from 'url:../../img/truck/img_truck_00006.jpg?as=webp';
import frame7 from 'url:../../img/truck/img_truck_00007.jpg?as=webp';
import frame8 from 'url:../../img/truck/img_truck_00008.jpg?as=webp';
import frame9 from 'url:../../img/truck/img_truck_00009.jpg?as=webp';
import frame10 from 'url:../../img/truck/img_truck_00010.jpg?as=webp';
import frame11 from 'url:../../img/truck/img_truck_00011.jpg?as=webp';
import frame12 from 'url:../../img/truck/img_truck_00012.jpg?as=webp';
import frame13 from 'url:../../img/truck/img_truck_00013.jpg?as=webp';
import frame14 from 'url:../../img/truck/img_truck_00014.jpg?as=webp';
import frame15 from 'url:../../img/truck/img_truck_00015.jpg?as=webp';
import frame16 from 'url:../../img/truck/img_truck_00016.jpg?as=webp';
import frame17 from 'url:../../img/truck/img_truck_00017.jpg?as=webp';
import frame18 from 'url:../../img/truck/img_truck_00018.jpg?as=webp';
import frame19 from 'url:../../img/truck/img_truck_00019.jpg?as=webp';
import frame20 from 'url:../../img/truck/img_truck_00020.jpg?as=webp';
import frame21 from 'url:../../img/truck/img_truck_00021.jpg?as=webp';
import frame22 from 'url:../../img/truck/img_truck_00022.jpg?as=webp';
import frame23 from 'url:../../img/truck/img_truck_00023.jpg?as=webp';
import frame24 from 'url:../../img/truck/img_truck_00024.jpg?as=webp';
import frame25 from 'url:../../img/truck/img_truck_00025.jpg?as=webp';
import frame26 from 'url:../../img/truck/img_truck_00026.jpg?as=webp';
import frame27 from 'url:../../img/truck/img_truck_00027.jpg?as=webp';
import frame28 from 'url:../../img/truck/img_truck_00028.jpg?as=webp';
import frame29 from 'url:../../img/truck/img_truck_00029.jpg?as=webp';
import frame30 from 'url:../../img/truck/img_truck_00030.jpg?as=webp';
import frame31 from 'url:../../img/truck/img_truck_00031.jpg?as=webp';
import frame32 from 'url:../../img/truck/img_truck_00032.jpg?as=webp';
import frame33 from 'url:../../img/truck/img_truck_00033.jpg?as=webp';
import frame34 from 'url:../../img/truck/img_truck_00034.jpg?as=webp';
import frame35 from 'url:../../img/truck/img_truck_00035.jpg?as=webp';
import frame36 from 'url:../../img/truck/img_truck_00036.jpg?as=webp';
import frame37 from 'url:../../img/truck/img_truck_00037.jpg?as=webp';
import frame38 from 'url:../../img/truck/img_truck_00038.jpg?as=webp';
import frame39 from 'url:../../img/truck/img_truck_00039.jpg?as=webp';
import frame40 from 'url:../../img/truck/img_truck_00040.jpg?as=webp';
import frame41 from 'url:../../img/truck/img_truck_00041.jpg?as=webp';
import frame42 from 'url:../../img/truck/img_truck_00042.jpg?as=webp';
import frame43 from 'url:../../img/truck/img_truck_00043.jpg?as=webp';
import frame44 from 'url:../../img/truck/img_truck_00044.jpg?as=webp';
import frame45 from 'url:../../img/truck/img_truck_00045.jpg?as=webp';
import frame46 from 'url:../../img/truck/img_truck_00046.jpg?as=webp';
import frame47 from 'url:../../img/truck/img_truck_00047.jpg?as=webp';
import frame48 from 'url:../../img/truck/img_truck_00048.jpg?as=webp';
import frame49 from 'url:../../img/truck/img_truck_00049.jpg?as=webp';
import frame50 from 'url:../../img/truck/img_truck_00050.jpg?as=webp';
import frame51 from 'url:../../img/truck/img_truck_00051.jpg?as=webp';
import frame52 from 'url:../../img/truck/img_truck_00052.jpg?as=webp';
import frame53 from 'url:../../img/truck/img_truck_00053.jpg?as=webp';
import frame54 from 'url:../../img/truck/img_truck_00054.jpg?as=webp';
import frame55 from 'url:../../img/truck/img_truck_00055.jpg?as=webp';
import frame56 from 'url:../../img/truck/img_truck_00056.jpg?as=webp';
import frame57 from 'url:../../img/truck/img_truck_00057.jpg?as=webp';
import frame58 from 'url:../../img/truck/img_truck_00058.jpg?as=webp';
import frame59 from 'url:../../img/truck/img_truck_00059.jpg?as=webp';
import frame60 from 'url:../../img/truck/img_truck_00060.jpg?as=webp';
import frame61 from 'url:../../img/truck/img_truck_00061.jpg?as=webp';
import frame62 from 'url:../../img/truck/img_truck_00062.jpg?as=webp';
import frame63 from 'url:../../img/truck/img_truck_00063.jpg?as=webp';
import frame64 from 'url:../../img/truck/img_truck_00064.jpg?as=webp';
import frame65 from 'url:../../img/truck/img_truck_00065.jpg?as=webp';
import frame66 from 'url:../../img/truck/img_truck_00066.jpg?as=webp';
import frame67 from 'url:../../img/truck/img_truck_00067.jpg?as=webp';
import frame68 from 'url:../../img/truck/img_truck_00068.jpg?as=webp';
import frame69 from 'url:../../img/truck/img_truck_00069.jpg?as=webp';
import frame70 from 'url:../../img/truck/img_truck_00070.jpg?as=webp';
import frame71 from 'url:../../img/truck/img_truck_00071.jpg?as=webp';
import frame72 from 'url:../../img/truck/img_truck_00072.jpg?as=webp';
import frame73 from 'url:../../img/truck/img_truck_00073.jpg?as=webp';
import frame74 from 'url:../../img/truck/img_truck_00074.jpg?as=webp';
import frame75 from 'url:../../img/truck/img_truck_00075.jpg?as=webp';
import frame76 from 'url:../../img/truck/img_truck_00076.jpg?as=webp';
import frame77 from 'url:../../img/truck/img_truck_00077.jpg?as=webp';
import frame78 from 'url:../../img/truck/img_truck_00078.jpg?as=webp';
import frame79 from 'url:../../img/truck/img_truck_00079.jpg?as=webp';

export const truckFrames = [frame0, frame1, frame2, frame3, frame4, frame5, frame6, frame7, frame8, frame9, frame10, frame11, frame12, frame13, frame14, frame15, frame16, frame17, frame18, frame19, frame20, frame21, frame22, frame23, frame24, frame25, frame26, frame27, frame28, frame29, frame30, frame31, frame32, frame33, frame34, frame35, frame36, frame37, frame38, frame39, frame40, frame41, frame42, frame43, frame44, frame45, frame46, frame47, frame48, frame49, frame50, frame51, frame52, frame53, frame54, frame55, frame56, frame57, frame58, frame59, frame60, frame61, frame62, frame63, frame64, frame65, frame66, frame67, frame68, frame69, frame70, frame71, frame72, frame73, frame74, frame75, frame76, frame77, frame78, frame79];
